<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-2" :dir="locale === 'ar' ? 'rtl' : 'ltr'">
      <div class="col-md-8 position-relative">
        <input
          type="text"
          class="form-control form-control-sm"
          :class="locale === 'ar' ? 'ps-5' : 'pe-5'"
          :placeholder="$t('classes.table.searchPlaceholder')"
          v-model="searchTerm"
          @keyup.enter="handleSearch"
          @blur="handleSearch"
        />
        <span class="position-absolute top-50 translate-middle-y" :class="locale === 'ar' ? 'start-0 ps-3' : 'end-0 pe-3'">
          <i class="fas fa-search"></i>
        </span>
      </div>
      
      <div class="col-md-4">
        <button class="btn btn-secondary btn-sm w-100" @click="navigateToAddClass" v-can="'classes.create'">
          <i class="fas fa-plus"></i>
          {{ $t('classes.actions.addNew') }}

        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineEmits, defineExpose } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { debounce } from 'lodash';
const { locale } = useI18n();
const router = useRouter();
const emit = defineEmits(['search']);

const searchTerm = ref('');


const debouncedSearch = debounce(() => {
  emit('search', searchTerm.value.trim());
}, 500);

watch(searchTerm, () => {
  debouncedSearch();
});

const handleSearch = () => {
  debouncedSearch.cancel(); 
  emit('search', searchTerm.value.trim());
};

const clearSearch = () => {
  searchTerm.value = '';
  emit('search', '');
};

const navigateToAddClass = () => {
  router.push('/classes/add');
};

defineExpose({
  clearSearch
});
</script>